import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/referrals/wellbeing')({
    component: RouteComponent,
    staticData: {
        crumb: {
            label: 'Health & Wellbeing'
        }
    }
})

function RouteComponent() {
    return <Outlet />
}
